import * as React from 'react';
import {Text, HStack} from '@packages/systems/spring';
import PropertyList, {
  PropertyListItem,
} from '@packages/systems/ui/shared-ui/PropertyList';
import type {ConfiguredOption} from '@packages/systems/designer/forms/types';

const SendToOptionLabel = ({
  label,
  endLabel,
}: {
  label: string;
  endLabel: string;
}) => {
  return (
    <HStack align="center" justify="space-between">
      <Text truncateToLines={1}>{label}</Text>
      {endLabel && (
        <Text colorVariant="secondary">{endLabel.toUpperCase()}</Text>
      )}
    </HStack>
  );
};

const SendToOptionRow = ({item}: {item: ConfiguredOption}) => {
  const {id, label, iconComponent, onEdit, endLabel} = item;

  return (
    <PropertyListItem
      id={id}
      label={<SendToOptionLabel label={label} endLabel={endLabel || ''} />}
      icon={iconComponent}
      onClick={onEdit}
    />
  );
};

export interface ConfiguredOptionsListProps {
  options: ConfiguredOption[];
  onItemDeleted: (id: string) => void;
}

export function ConfiguredOptionsList({
  options,
  onItemDeleted,
}: ConfiguredOptionsListProps) {
  if (!options.length) return null;

  return (
    <PropertyList
      deletable
      disabled={false}
      items={options}
      renderItem={(item) => <SendToOptionRow item={item} />}
      useLargeIcons
      onItemDeleted={onItemDeleted}
    />
  );
}
